import React from "react";
import { ThemeProvider } from "@material-ui/core/styles";
import { defaultTheme, darkTheme } from "../theme";
import { useRecoilState } from "recoil";
import { themeState } from "../Atoms/uiAtom";

const CustomThemeProvider = ({ children }) => {
  // Use theme from store
  const [theme] = useRecoilState(themeState);
  // Choose which theme to inject into layout
  const themeType = theme === "darkTheme" ? darkTheme : defaultTheme;

  return <ThemeProvider theme={themeType}>{children}</ThemeProvider>;
};

export default CustomThemeProvider;
